import { combineReducers } from 'redux';
import userReducer from './userReducer';
import userBehaviorReducer from './userBehaviorReducer';
import rothRetirementAccountsReducer from './rothRetirementAccountsReducer';
import normalRetirementAccountsReducer from './normalRetirementAccountsReducer';
import peopleReducer from './peopleReducer';
import regularAccountsReducer from './regularAccountsReducer';
import { annuitiesReducer, trustFundsReducer, pensionsReducer, unclassifiedIncomesReducer } from './incomeReducers';
import modulesReducer from './modulesReducer';
import simulationReducer from './simulationReducer';
import tempSimulationReducer from './tempSimulationReducer';
import planImpactReducer from './planImpactReducer';
import projectedIncomesReducer from './projectedIncomesReducer';
import socialSecurityQuizReducer from './socialSecurityQuizReducer';
import onboardingReducer from './onboardingReducer';
import contentPagesReducer from './contentPagesReducer';
import toolsReducer from './toolsReducer';
import uiReducer from './uiReducer';

export default combineReducers({
  user: userReducer,
  userBehavior: userBehaviorReducer,
  modules: modulesReducer,
  rothRetirementAccounts: rothRetirementAccountsReducer,
  normalRetirementAccounts: normalRetirementAccountsReducer,
  people: peopleReducer,
  regularAccounts: regularAccountsReducer,
  annuities: annuitiesReducer,
  trustFunds: trustFundsReducer,
  pensions: pensionsReducer,
  unclassifiedIncomes: unclassifiedIncomesReducer,
  simulations: simulationReducer,
  tools: toolsReducer,
  tempSimulations: tempSimulationReducer,
  planImpact: planImpactReducer,
  projectedIncomes: projectedIncomesReducer,
  socialSecurityQuiz: socialSecurityQuizReducer,
  onboarding: onboardingReducer,
  contentPages: contentPagesReducer,
  ui: uiReducer,
});
